export const getConfiguredMinimumSalesOrderQuantity = (product = {}) => {
	const rawValue =
		product?.minimum_sales_order_quantity ??
		product?.minimum_order_quantity ??
		product?.minimumSalesOrderQuantity ??
		product?.minimumOrderQuantity ??
		product?.product_data?.minimum_sales_order_quantity ??
		product?.product_data?.minimum_order_quantity ??
		product?.productData?.minimum_sales_order_quantity ??
		product?.productData?.minimum_order_quantity ??
		product?.replacement_minimum_sales_order_quantity ??
		product?.replacement?.replacement_minimum_sales_order_quantity ??
		null;

	const quantity = Number(rawValue);
	return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
};

export const getMinimumSalesOrderQuantity = (product = {}) => {
	const quantity = getConfiguredMinimumSalesOrderQuantity(product);
	return quantity > 0 ? quantity : 1;
};

export const getMultipleSalesOrderQuantity = (product = {}) => {
	const rawValue =
		product?.multiple_sales_order_quantity ??
		product?.multiple_order_quantity ??
		product?.multipleSalesOrderQuantity ??
		product?.multipleOrderQuantity ??
		product?.product_data?.multiple_sales_order_quantity ??
		product?.product_data?.multiple_order_quantity ??
		product?.productData?.multiple_sales_order_quantity ??
		product?.productData?.multiple_order_quantity ??
		product?.replacement_multiple_sales_order_quantity ??
		product?.replacement?.replacement_multiple_sales_order_quantity ??
		null;

	const quantity = Number(rawValue);
	return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
};

export const parseOrderQuantity = (quantity) => {
	if (quantity === null || quantity === undefined || quantity === "") return Number.NaN;
	if (typeof quantity === "string") {
		const normalized = quantity.trim().replace(/,/g, ".");
		return Number(normalized);
	}
	return Number(quantity);
};

export const followsMultipleSalesOrderQuantity = (quantity, product = {}) => {
	const multipleQuantity = getMultipleSalesOrderQuantity(product);
	if (!multipleQuantity) return true;
	const minimumQuantity = getConfiguredMinimumSalesOrderQuantity(product);
	const baseQuantity = minimumQuantity || multipleQuantity;
	const steps = (quantity - baseQuantity) / multipleQuantity;
	return steps >= 0 && Math.abs(steps - Math.round(steps)) < 0.000001;
};

export const normalizeOrderQuantity = (quantity, product = {}) => {
	const parsedQuantity = parseOrderQuantity(quantity);
	const safeQuantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0
		? parsedQuantity
		: 1;
	const minimumQuantity = getMinimumSalesOrderQuantity(product);
	const configuredMinimumQuantity = getConfiguredMinimumSalesOrderQuantity(product);
	const multipleQuantity = getMultipleSalesOrderQuantity(product);
	let normalizedQuantity = Math.max(safeQuantity, minimumQuantity);
	if (multipleQuantity && !followsMultipleSalesOrderQuantity(normalizedQuantity, product)) {
		const baseQuantity = configuredMinimumQuantity || multipleQuantity;
		normalizedQuantity = baseQuantity + Math.ceil((normalizedQuantity - baseQuantity) / multipleQuantity) * multipleQuantity;
	}
	return normalizedQuantity;
};

export const formatOrderQuantity = (quantity) => {
	const parsedQuantity = Number(quantity);
	if (!Number.isFinite(parsedQuantity)) return "";
	return Number.isInteger(parsedQuantity)
		? String(parsedQuantity)
		: String(parsedQuantity).replace(/\.?0+$/, "");
};

